<template>
	<Floater offsetDistance="0" :arrow="false">
		<button class="btn btn-sm flex items-center gap-2">
			<Languages size="16" />
			{{ currentLanguage?.toUpperCase() }}
			<ChevronDown />
		</button>
		<template #content="{ close }">
			<ul class="menu menu-compact p-1">
				<li>
					<button @click="() => changeLanguage('en', close)">{{ t('layout.language.english') }}</button>
				</li>
				<li>
					<button @click="() => changeLanguage('de', close)">{{ t('layout.language.german') }}</button>
				</li>
			</ul>
		</template>
	</Floater>
</template>

<script setup lang="ts">
	import { ref, computed, watch } from 'vue'
	import { useI18n } from 'vue-i18n'
	import Floater from '@/components/common/Floater.vue'
	import { ChevronDown, Languages } from 'lucide-vue-next'
	import { _translations } from './_translations'

	declare global {
		interface Window {
			__appLanguage?: ReturnType<typeof ref>
		}
	}
	const sharedLang = (window.__appLanguage ||= ref<string>(localStorage.getItem('language') || 'en'))

	// expose for template and logic
	const currentLanguage = computed<string>(() => sharedLang.value as string)
	const { locale } = useI18n()
	const { t } = useI18n(_translations)

	// Apply everything needed when lang changes
	function applyLanguage(lang: string) {
		locale.value = lang
		document.documentElement.setAttribute('lang', lang)
		localStorage.setItem('language', lang)
	}

	function changeLanguage(lang: string, close: () => void) {
		sharedLang.value = lang
		applyLanguage(lang)
		close()
	}

	// whenever sharedLang changes (in _any_ instance), re-apply site-wide
	watch(sharedLang, (lang) => applyLanguage(lang as string), { immediate: true })
</script>
